import { Component } from '@angular/core';
import { GoogleAnalyticsService } from '../google-analytics.service';

@Component({
  selector: 'app-collaborators',
  templateUrl: './collaborators.component.html',
  styleUrl: './collaborators.component.css',
  standalone: true
})
export class CollaboratorsComponent {
  constructor(public gaService: GoogleAnalyticsService) {
  }
}
